export default "__VITE_ASSET__Ce6ieGG___"